module.exports = __webpack_public_path__ + "static/img/53_fish.2d278488.jpg";